var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app flex-row align-items-center" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _vm.resetPassword
              ? _c(
                  "b-modal",
                  {
                    staticClass: "aligned",
                    attrs: {
                      title: "Please Reset Password",
                      "hide-footer": "",
                    },
                    on: {
                      ok: function ($event) {
                        _vm.resetPassword = false
                      },
                    },
                    model: {
                      value: _vm.resetPassword,
                      callback: function ($$v) {
                        _vm.resetPassword = $$v
                      },
                      expression: "resetPassword",
                    },
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "Password needs to be at least 8 characters long. It has to have at least "
                      ),
                      _c("br"),
                      _vm._v(
                        "1 upper case character, 1 lower case character, 1 number "
                      ),
                      _c("br"),
                      _vm._v(" and 1 special character @#%!$"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.changePassword.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "resetModal" },
                          [
                            _c(
                              "b-alert",
                              {
                                attrs: {
                                  variant: "danger",
                                  show: _vm.error != "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.error) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password",
                                },
                              ],
                              staticClass: "form-control login",
                              attrs: {
                                type: "password",
                                required: "",
                                placeholder: "Password",
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.password = $event.target.value
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary login center-block modalSubmit",
                            attrs: { type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n              Reset Password\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "login-footer" }, [
      _c("img", {
        staticClass: "labs-logo login center-block",
        attrs: { src: "static/img/labs_logo.svg", alt: "labs-img" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }